import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueGtm from '@gtm-support/vue2-gtm';
import VueCookies from 'vue-cookies';
import VueAxios from 'vue-axios';
import axios from 'axios';
import App from './App.vue';
import router from './router';
import store from './store';
import 'reset-css';
import 'swiper/css/swiper.css';

Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(VueCookies, { expires: '7d' });
Vue.use(VueAxios, axios);
Vue.use(VueGtm, {
  id: 'GTM-5BFKWVK',
  enabled: process.env.NODE_ENV === 'production',
  debug: false,
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
